<template>
  <div>
    <v-navigation-drawer v-if="isShow" app style="border-right: solid 1px #e0e0e0" permanent>
      <!-- v-listにnavプロパティを付けるとサイドバーらしいスリムな見た目になります -->
      <v-list v-if="currentCompany" nav density="compact">
        <div v-for="(menu, m) in displayMenuItems" :key="m">
          
          <!-- subheaderの文字を小さくし、高さを抑える -->
          <v-list-subheader style="font-size: 11px; height: 32px; min-height: 32px;">
            {{ menu.name }}
          </v-list-subheader>

          <v-list-item
            v-for="(item, i) in currentCompany?.applicationPlan.operationWeb.featureGroups.find(
              (f) => f.name == menu.name
            )?.features"
            v-show="item.isEnabled" 
            :key="i"
            :to="menu.features.find((m) => m.slug == item.slug)?.path"
            :target="menu.features.find((m) => m.slug == item.slug)?.target"
            link
            density="compact"
            min-height="32"
          >
            <!-- v-list-item-titleに直接書く。全角スペースよりpaddingで調整がおすすめ -->
            <v-list-item-title class="pl-4" style="font-size: 13px;">
              {{ item.name }}
            </v-list-item-title>
          </v-list-item>
        </div>

        <!-- v-list-item-groupはV3では必須ではなくなりました -->
        <v-divider class="my-2"></v-divider>
        <v-list-item @click="logout" density="compact" min-height="32">
          <v-list-item-title class="pl-4" style="font-size: 13px;">ログアウト</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script lang="ts">
import LocalDataService from "@/service/LocalDataService";
import { OperationCompanyResponse } from "chaild-api/lib";
import { defineComponent } from "vue";
import { navMenuItems } from "@/constants/navigation";
import { meModule } from "@/store/dataModule/meModule";

export default defineComponent({
  data() {
    return {
      navMenuItems: navMenuItems,
    };
  },

  computed: {
    displayMenuItems() {
      const excludeNames = ['指導計画'];
      return this.navMenuItems.filter(menu => !excludeNames.includes(menu.name));
    },
    isShow: function (): boolean {
      if (this.$route.path == "/select-company") {
        return false;
      } else {
        return true;
      }
    },
    currentCompany: function (): OperationCompanyResponse | null {
      if (meModule.company) {
        return meModule.company;
      } else {
        return LocalDataService.getCompany();
      }
    },
  },

  methods: {
    logout() {
      const answer = confirm("ログアウトしますか？");
      if (answer) {
        this.$router.push({ path: "/logout" });
      }
    },
  },
});
</script>
